import XLSX from "xlsx-js-style";

const HEADER_CELL_STYLE = {
  font: { bold: true, name: "Calibri", sz: 11 },
};

const toHeaderCell = (label) => ({
  v: String(label),
  t: "s",
  s: HEADER_CELL_STYLE,
});

/**
 * xlsx-js-style only applies styles when cells are created (aoa_to_sheet),
 * not when assigning ws["A1"].s after json_to_sheet.
 *
 * @param {object[]} rows - Array of plain objects (keys become column headers)
 * @param {{ sheetName?: string, fileName: string }} options
 */
export function exportRowsToExcel(rows, { sheetName = "Sheet1", fileName }) {
  if (!rows?.length) return false;

  const headers = Object.keys(rows[0]);
  const headerRow = headers.map(toHeaderCell);
  const dataRows = rows.map((row) =>
    headers.map((key) => {
      const value = row[key];
      return value ?? "";
    }),
  );

  const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
  return true;
}
